import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { NavigateFunction } from 'react-router-dom';

const showInactivityPrompt = (nextAction: () => void): void => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
        title: 'Are you still there?',
        text: 'Do you want to continue?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, continue',
        cancelButtonText: 'No, leave',
        timer: 8000, // 8 seconds timeout
        timerProgressBar: true, // Show timer as progress bar
        willClose: () => {
            console.log('Inactivity modal closed');
        }
    }).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer || result.dismiss === Swal.DismissReason.cancel) {
            // navigate(navigateTo); // Navigate to the specified page
            // before doing next action, display 'You have been inactive for too long. Please start again.' message (info)
            // MySwal.fire({
            //     title: 'You have been inactive for too long.',
            //     text: 'Please start again.',
            //     // icon: 'error',
            //     icon: 'info',
            //     timer: 5000, // 5 seconds
            //     showConfirmButton: false, // Hide button
            //     willClose: () => {
            //         nextAction(); // do next action
            //     }
            // });

            nextAction(); // do next action
        }
    });
};

export default showInactivityPrompt;